module.exports = __webpack_public_path__ + "img/product-preview1.c78bfb4e.png";